import * as yup from 'yup';

export const orderSchema = yup.object({
  basket: yup.array().of(
    yup.object({
      type: yup.string().required(),
      items: yup.array().of(
        yup.object({
          type: yup.string().required(),
          name: yup.string(),
          manufacturer: yup.string().nullable(),
          model: yup.lazy(value =>
            typeof value === 'string'
              ? yup.string()
              : typeof value === 'number'
                ? yup.number()
                : yup.mixed().nullable()
          ),


          quantity: yup.number().nullable(),
          color: yup.object().nullable(),
          imagePath: yup.string().nullable(),
          price: yup.object().nullable()
            .required(),
        })
      ),
    })
  )
    .required(),
  steps: yup.object({
    current: yup.object({
      step: yup.string().required(),
      type: yup.string().required(),
      data: yup.object().required(),
    }).required(),
    next: yup.array().required(),
    previous: yup.array().required(),
  }).required(),
  order: yup.object({
    referenceId: yup.number().required(),
  }).required(),
});

